import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function OperatorTenantListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Operator Tenant"}
                            deleteModalQuestion={"Are you sure you want to delete this Operator Tenant?"}
                            editHref={"/operator-tenant/update"}
                            detailsHref={"/operator-tenant/details"}
                            objectKeys={["id", "tenant.external_id", "operator.company_name"]}
                            columnTitles={[
                                "ID", "Tenant External ID", "Operator"
                            ]}
                            insertHref={"/operator-tenant/create"}
                            insertTitle={"Add Operator Tenant"}
                            pageTitle={"Operator Tenants"}
                            deleteEndpoint={"operator-tenant/delete"}
                            readEndpoint={"operator-tenant/read"}
                            relations={[ "tenant", "operator"]}
                            />
        </>
    )
}

export default OperatorTenantListPage;